// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__nCy2P","productName":"Table_productName__1U73W"};